/*
 * Application Insights JavaScript SDK - React Native Plugin, 4.3.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
import { getReactNativeDeviceInfo } from "./DeviceInfo/ReactNativeDeviceInfo";
import { ReactNativeManualDevicePlugin } from "./ReactNativeManualDevicePlugin";
var ReactNativePlugin = /** @class */ (function (_super) {
    __extends(ReactNativePlugin, _super);
    function ReactNativePlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReactNativePlugin.prototype.getDeviceInfoModule = function (_deviceInfoModule) {
        return _deviceInfoModule || getReactNativeDeviceInfo();
    };
    return ReactNativePlugin;
}(ReactNativeManualDevicePlugin));
export { ReactNativePlugin };
//# sourceMappingURL=ReactNativePlugin.js.map